export default __webpack_public_path__ + "static/media/iStar-m.6d415956.svg";